import { UITypes } from "types"

export enum UserRole {
  // Vendor
  VendorAdmin = 1,

  // Sales
  SalesManager = 2,

  // Warehouse
  VendorWarehouse = 3,
  WarehouseManager = 8,

  // Contractor
  ContractorManager = 4,
  ContractorAdmin = 9,
  ContractorEngineer = 10,
  ContractorTechnician = 11,
}

export const UserRoleLabel: Record<UserRole, UITypes.UserRole> = {
  [UserRole.VendorAdmin]: "vendor-admin",
  [UserRole.SalesManager]: "sales-manager",
  [UserRole.VendorWarehouse]: "vendor-warehouse",
  [UserRole.ContractorManager]: "contractor-manager",
  [UserRole.WarehouseManager]: "warehouse-manager",
  [UserRole.ContractorAdmin]: "contractor-admin",
  [UserRole.ContractorEngineer]: "contractor-engineer",
  [UserRole.ContractorTechnician]: "contractor-technician",
}

export const checkRoleType = (value?: number): UITypes.UserRole | undefined =>
  value ? UserRoleLabel[value as UserRole] : undefined
